<span class="teaser-picks"> {{ picksCount }} {{ teaserBetMessages?.messages?.ResultTeaserPick }}</span>
<span class="seperator"> - </span>
<span class="teaser-points"> {{ teaserPoints }} {{ teaserBetMessages?.messages?.ResultTeaserPoints }} </span>
